module.exports = __webpack_public_path__ + "img/banner2.07bc3c61.jpg";